import GlobalStyles from "styles/globalStyles";
import { ThemeProvider } from "styled-components";
import light from "styles/themes/light";
import AppRoutes from "routes/AppRoutes";
import { Offline } from "react-detect-offline";
import ConnectionStatus from "../src/components/Error/ConnectionStatus";
function App() {
  return (
    <ThemeProvider theme={light}>
      <Offline>
        <ConnectionStatus />
      </Offline>
      <GlobalStyles />
      <AppRoutes />
    </ThemeProvider>
  );
}

export default App;
